<template>
  <section class="section_team">
    <!-- Floating case study on right top -->
    <!-- <FloatingCaseStudy :caseColor="caseColor" :caseText='caseText'></FloatingCaseStudy> -->
    <!-- Slider progress bar -->
    <div class="progress__box">
      <div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100">
        <!-- <span class="slider__label sr-only"></span> -->
      </div>
    </div>
    <!-- All animating objects -->
    <!-- <div class="section__team--bg">

    </div>-->
    <div class="section__team--box">
      <div class="section__team--content">
        <!-- <transition name="fade"> -->
         <flickity ref="flickity" :options="flickityOptions">
            <!-- <div style="width: 100%; display: inline-block;"> -->

            <!-- srcset="https://ik.imagekit.io/intervi/tr:w-596,h-894/interactivevision-www17_bTdSFkWNY_.jpg" -->

            <div>
              <div class="person__box">
                <div class="person__box--image">
                  <img src="https://ik.imagekit.io/intervi/Mariusz_NsqTDBFH8hs.jpg"  alt="Zdjęcie na żółtym tle Mariusza">
                </div>
                <div class="person__box--text">
                  <h2>Mariusz</h2>
                  <p>Founder & CEO</p>
                </div>
              </div>
            </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/ralph-www_3mH12_jEEHA_z1pB548g4.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Ralpha">
               </div>
               <div class="person__box--text">
                 <h2>Ralph</h2>
                 <p>Managing Director</p>
               </div>
             </div>
           </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www3_FP4OueO423.jpg" class="lazyload" alt="Zdjęcie na różowym tle Agnieszki">
                </div>
                <div class="person__box--text">
                  <h2>Aga</h2>
                  <p>Photographer</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www2_dMAk-saUP.jpg" class="lazyload" alt="Zdjęcie na zielonym tle Grzegorza">
                </div>
                <div class="person__box--text">
                  <h2>Grzesiek</h2>
                  <p>Account Executive</p>
                </div>
              </div>
            </div>
            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www20_Zt3ql0tg8G.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Marii">
                </div>
                <div class="person__box--text">
                  <h2>Marysia</h2>
                  <p>Office Manager</p>
                </div>
              </div>
            </div>
            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www19_l0Iyc81emT.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Mariusza">
                </div>
                <div class="person__box--text">
                  <h2>Mariusz</h2>
                  <p>Graphic Designer</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www18_JOlRVmtFg.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Gabrieli">
                </div>
                <div class="person__box--text">
                  <h2>Gabrysia</h2>
                  <p>Social Media Specjalist</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www13_5Tc4mbtkoW.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Bartłomieja">
                </div>
                <div class="person__box--text">
                  <h2>Bartek</h2>
                  <p>Graphic Designer</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www11_KdtS5N-8u.jpg" class="lazyload" alt="Zdjęcie na różowym tle Marzeny">
                </div>
                <div class="person__box--text">
                  <h2>Marzena</h2>
                  <p>Social Media Team Leader</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www14_pv8rO6TN7.jpg" class="lazyload" alt="Zdjęcie na różowym tle Moniki">
                </div>
                <div class="person__box--text">
                  <h2>Monika</h2>
                  <p>Social Media Coordinator</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www8_v4uTP39Rpq.jpg" class="lazyload" alt="Zdjęcie na zielonym tle Jakuba">
                </div>
                <div class="person__box--text">
                  <h2>Jakub</h2>
                  <p>Social Media Specjalist</p>
                </div>
              </div>
            </div>

            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www10_IR7FLW3Ha.jpg" class="lazyload" alt="Zdjęcie na czerwonym tle Alexa">
                </div>
                <div class="person__box--text">
                  <h2>Alex</h2>
                  <p>Social Media Specjalist</p>
                </div>
              </div>
            </div>


            <div>
              <div class="person__box">
                <div class="person__box--image">
                <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www6_LNIz6osLTu.jpg" class="lazyload" alt="Zdjęcie na różowym tle Justyny">
                </div>
                <div class="person__box--text">
                  <h2>Justyna</h2>
                  <p>Social Media Specjalist</p>
                </div>
              </div>
            </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/ola-2_5pkDrY1UM.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Oli">
               </div>
               <div class="person__box--text">
                 <h2>Ola</h2>
                 <p>Social Media Specjalist</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/_ukasz_4lnFldp-gp8.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Łukasza">
               </div>
               <div class="person__box--text">
                 <h2>Łukasz</h2>
                 <p>Project Manager</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/team/tr:w-650,h-976/kamil_musia__QtVVsMDTe.jpg" class="lazyload" alt="Zdjęcie na niebieskim tle Kamila">
               </div>
               <div class="person__box--text">
                 <h2>Kamil</h2>
                 <p>Back-end Developer</p>
               </div>
             </div>
           </div>


           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/team/tr:w-650,h-976/michal-www_720_kS7U-uTJ7vV.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Michała">
               </div>
               <div class="person__box--text">
                 <h2>Kamil</h2>
                 <p>Project Manager</p>
               </div>
             </div>
           </div>
           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/team/tr:w-650,h-976/tomek_l_cznar_xfZapAMGY.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Tomka">
               </div>
               <div class="person__box--text">
                 <h2>Tomek</h2>
                 <p>Front-end Developer</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/interactivevision-www13_5Tc4mbtkoW.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Bartłomieja">
               </div>
               <div class="person__box--text">
                 <h2>Bartłomiej</h2>
                 <p>Graphic Designer</p>
               </div>
             </div>
           </div>

           <div>
           <div class="person__box">
             <div class="person__box--image">
               <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/Karol_wG55XaDeX.jpg" class="lazyload" alt="Zdjęcie na różowym tle Karola">
             </div>
             <div class="person__box--text">
               <h2>Karol</h2>
               <p>Front-end Developer</p>
             </div>
           </div>
         </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/Daria_US9zCTOWN.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Darii">
               </div>
               <div class="person__box--text">
                 <h2>Daria</h2>
                 <p>Graphic Designer</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/Patrycja_w3sRnlFpL.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Patrycji">
               </div>
               <div class="person__box--text">
                 <h2>Patrycja</h2>
                 <p>Project Manager</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/team/tr:w-650,h-976/wojtek_czekirda_DmwDsc1xY.jpg" class="lazyload" alt="Zdjęcie na żółtym tle Wojtka">
               </div>
               <div class="person__box--text">
                 <h2>Wojtek</h2>
                 <p>Front-end Developer</p>
               </div>
             </div>
           </div>

           <div>
             <div class="person__box">
               <div class="person__box--image">
                 <img data-src="https://ik.imagekit.io/intervi/tr:w-650,h-976/Kamil_BRvW-AukzAM.jpg" class="lazyload" alt="Zdjęcie na fioletowym tle Kamila">
               </div>
               <div class="person__box--text">
                 <h2>Kamil</h2>
                 <p>Senior Fullstack Developer</p>
               </div>
             </div>
           </div>

          </flickity>
        <!-- </transition> -->
      </div>

        <!-- :floatingContactColor="floatingContactColor"
        :floatingContactLetterColor="floatingContactLetterColor" -->

      <FloatingContact
      />
    </div>

    <!-- <div class="section__team--footer">    <div class="section__team--rectangle">

    </div></div>-->
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingCaseStudy from "@/components/small-components/FloatingCaseStudy";
import FloatingContact from "@/components/small-components/FloatingContact";
import Flickity from "vue-flickity";

import wheel from 'wheel';
import normalizeWheel from 'normalize-wheel';

export default {
  name: "ComponentTeam",
  data() {
    return {
      flickityOptions: {
        draggable: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: true,
        groupCells: false,
        selectedAttraction: 0.00037,
        // friction: 0.08
        cellAlign: 'left',
        contain: true
      },
      caseColor: "light-gray",
      sliderScrollComplete: true
    };
  },
  methods: {
    progresss() {
      this.$refs.flickity.on('scroll', (progress) => {
        let progressBarComplete = (progress * 100).toFixed(0);

        $('.progress').css("background-size", progressBarComplete + "% 100%");

        // Block scroll till team slider completes
        // if (progress > 0.9 && this.sliderScrollComplete === false) {
        //   this.sliderScrollComplete = true;
        // } else if (progress < 0.8 && this.sliderScrollComplete !== false) {
        //   this.sliderScrollComplete = false;
        // }
      })

    },
    sliderResponsiveOptions() {
      // if ( matchMedia('screen and (max-width: 768px)').matches ) {
      //   this.flickityOptions.prevNextButtons = false;
      // }
    },
    moveSliderForward() {

      var _this = this;
      _this.$refs.flickity.next();
    },
    moveSliderBackward() {

      var _this = this;
      _this.$refs.flickity.previous();
    },
    moveSliderWithWheel() {

      let slider = this.$refs.flickity.$el;
      var _this = this;

      slider.addEventListener('wheel', function (event) {

        !_this.sliderScrollComplete && event.stopPropagation()

        let wheelNormalized = normalizeWheel(event);

        wheelNormalized.pixelY > 0 ? _this.moveSliderForward() : _this.moveSliderBackward();
        return true;

      })
    }
  },
  watch: {
    showTeam: function() {
      var _this = this;

      if (this.showTeam == true) {
        setTimeout(function() {
            _this.$refs.flickity.resize();
        }, 100);
      }
    }
  },
  mounted: function() {

    this.moveSliderWithWheel();
    this.progresss();

  },
  // Init components
  components: {
    SectionTitle,
    FloatingSocials,
    FloatingCaseStudy,
    FloatingContact,
    Flickity
  },
  props: ["showChild", "showTeam", "sections", "activeSection"]
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentTeam.vue